var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"route-host"},[_c('MyHeader',{staticClass:"my-header"}),_c('div',{staticClass:"content"},[_c('router-view')],1),_c('MyFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }